module.exports = __webpack_public_path__ + "img/ArmadilloHoldingSplint.3bdf77f4.gif";